// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","inner":"Footer_inner__NB0X+","footerText":"Footer_footerText__HLuh1","links":"Footer_links__vUbnJ","link":"Footer_link__c7GbB"};